import type { IconSvgObject } from './types';

const LabsIcon: IconSvgObject = [
  ["path", { d: "M16.5 21C14.567 21 13 19.433 13 17.5L13 3L20 3L20 17.5C20 19.433 18.433 21 16.5 21Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 3L11 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15.5 7H13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M20 11H13", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M6 11C6 11 10 13.5 10 16.75C10 19.0972 8.20914 21 6 21C3.79086 21 2 19.0972 2 16.75C2 13.5 6 11 6 11Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default LabsIcon;
